import {
  ItemSelectionType,
  UmpireComponentHeroGeneric,
} from '../umpire-component-hero-generic';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireProduct} from '../umpire-product';
import {UmpireProductCategory} from '../umpire-product-category';

export interface UmpireComponentProductList
  extends UmpireComponentHeroGeneric<UmpireComponentTypeEnum.PRODUCT_LIST> {
  title: string;
  external_url: string;
  external_url_label: string;
  products: UmpireProduct[];
  products_order: ProductOrder[];
  product_selections: Extract<
    ItemSelectionType,
    ItemSelectionType.auto | ItemSelectionType.manual
  >;
  category: UmpireProductCategory | null;
}

export interface ProductOrder {
  product_id: string;
  product_index: number;
}
